import { render, staticRenderFns } from "./officialTopupNewApp.vue?vue&type=template&id=3f3f8ae7&"
import script from "./officialTopupNewApp.vue?vue&type=script&lang=js&"
export * from "./officialTopupNewApp.vue?vue&type=script&lang=js&"
import style0 from "./officialTopupNewApp.vue?vue&type=style&index=0&id=3f3f8ae7&prod&lang=css&"
import style1 from "./officialTopupNewApp.vue?vue&type=style&index=1&id=3f3f8ae7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports